module.exports = __webpack_public_path__ + "static/media/empty_collection.ed0370e6.png";